import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Popconfirm, Table, Modal, Input } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import './styles.css'

const { Column } = Table

const setEmployeesField = (employeesId, employees) => {
    let employeesField = ''
    if (employeesId && Array.isArray(employeesId)) {
        employeesId.forEach((id, idx) => {
            if (employees?.[id]) {
                if (idx === employeesId.length - 1) {
                    employeesField = employeesField.concat(employees[id].name + '.')
                } else {
                    employeesField = employeesField.concat(employees[id].name + ', ')
                }
            }
        });
    }
    return employeesField
}

const TripsTable = ({ data, onRemoveTrip, loading, employees, onAddKilometers }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [kilometers, setKilometers] = useState('');

    const showModal = (record) => {
        setSelectedTrip(record);
        setKilometers(record.kilometers || '');
        setIsModalVisible(true);
    };

    const handleOk = () => {
        onAddKilometers(selectedTrip, kilometers);
        setIsModalVisible(false);
        setKilometers('');
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setKilometers('');
    };

    return (
        <>
            <Table className="reportWorkOrderTableCont" dataSource={data} rowKey="id" size="small" pagination={false} scroll={{ x: 1000 }}>
                <Column title="OT" dataIndex="workLabel" key="workLabel" align="center" width="15%" render={workLabel => workLabel !== "" ? workLabel : "--"}/>
                <Column title="Fecha Inicio" dataIndex="startDate" key="startDate" align="center" width="10%"/>
                <Column title="Fecha Fin" dataIndex="endDate" key="endDate" align="center" width="10%"/>
                <Column title="Localidad" dataIndex="locality" key="locality" align="center" width="20%"/>
                <Column title="Descripción" dataIndex="description" key="description" align="center" width="30%" render={description => description !== "" ? description : "--"}/>
                <Column title="Profesionales" dataIndex="employeesId" key="employeesId" align="center" width="10%" render={employeesId => employeesId && employeesId !== '' ? setEmployeesField(employeesId, employees) : '--'}/>
                <Column title="Kilómetros realizados" dataIndex="kilometers" key="kilometers" align="center" render={kilometers => kilometers !== undefined ? kilometers : '--'}/>
                <Column title="" dataIndex="kmButton" key="kmButton" align="center"render={(text, record) =>
                    <Button onClick={() => showModal(record)} style={{ marginLeft: 8 }}>
                        Cargar kilómetros realizados
                    </Button>
                }/>
                <Column title="" dataIndex="actions" key="actions" align="center" width="5%" render={(text, record) =>
                    <Popconfirm disabled={loading} title="Se borrará el viaje, ¿Continuar?"
                                onConfirm={() => onRemoveTrip(record)}>
                        <Button loading={loading}>{!loading && <DeleteOutlined style={{ color: 'red' }}/>}</Button>
                    </Popconfirm>
                }/>
            </Table>
            <Modal
                title="Cargar kilómetros realizados"
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <Input
                    type='number'
                    placeholder="Ingrese kilómetros realizados"
                    value={kilometers}
                    onChange={(e) => setKilometers(e.target.value)}
                />
            </Modal>
        </>
    )
}

TripsTable.propTypes = {
    data: PropTypes.array,
    employees: PropTypes.object,
    loading: PropTypes.bool
}

export default TripsTable